"use client";

import { IDashboardUserContest, IDashboardUserCourse } from "@/api";
import he from 'he';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  LinearProgress,
  Pagination,
  PaginationItem,
  IconButton,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDashboardContext } from "./Layout";
import logo from '../../images/imgcourse.png';
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const decodeHTMLEntities = (text: any) => {
  const textArea = document.createElement("textarea")
  textArea.innerHTML = text
  return textArea.value
}

export interface IDashboardUserContestExtend extends IDashboardUserContest {}

export default function MyContest() {
  const [contests, setContests] = useState<IDashboardUserContest["data"]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const { getDashboardUserContest } = useDashboardContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const fetchContest = async () => {
  //   setLoading(true);
  //   try {
  //     const allContest = await getDashboardUserContest(1, 10000);
  //     setTotalPages(Math.ceil(Number(allContest.count) / pageSize)); // Giả sử mỗi trang có 4 course
  //     setAllContest(allContest.data);
  //   } catch (error) {
  //     console.error("Error fetching contests:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchContest();
  // }, []);

  // useEffect(() => {
  //   const currentContests = allContest.slice(
  //     (currentPage - 1) * pageSize,
  //     currentPage * pageSize
  //   );
  //   setCurrentContest(currentContests)
  // }, [allContest, currentPage]);

  // const handlePageChange = (
  //   event: React.ChangeEvent<unknown>,
  //   value: number
  // ) => {
  //   setCurrentPage(value);
  // };

  // const truncateSummary = (summary: string, maxWords: number = 10) => {
  //   const words = summary.split(" "); // Tách câu thành mảng các từ
  //   if (words.length <= maxWords) {
  //     return summary; // Trả về nguyên văn nếu tổng số từ nhỏ hơn hoặc bằng 100
  //   }
  //   return words.slice(0, maxWords).join(" ") + "..."; // Lấy 100 từ đầu và thêm dấu ba chấm
  // };

  // const handleNextPage = () => {
  //   if (currentPage < totalPages) {
  //     setCurrentPage(currentPage + 1);
  //   }
  // };

  // const handlePrevPage = () => {
  //   if (currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // };

  useEffect(() => {
    const fetchContest = async () => {
      setLoading(true); // Bắt đầu tải dữ liệu
      try {
        
        const res = await getDashboardUserContest(currentPage.toString(), pageSize.toString());
        setContests(res.data);
        setTotalPages(Math.ceil(Number(res.count) / pageSize));
        setCount(res.count);
      } catch (error) {
        console.error("Error fetching badges:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchContest();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if(isMobile){
      setPageSize(1)
    }else{
      setPageSize(4)
    }
  }, [isMobile]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        mt: 4,
        flex: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          fontWeight: 500,
          mb: 3,
        }}
      >
        My Contests
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <CircularProgress />
        </Box>
      ) : count === 0 ? (
        <Typography
          sx={{
            color: "rgb(102, 102, 102)",
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          No data available
        </Typography>
      ) : (
        <>
          <Box sx={{ position: "relative", mb: 3 }}>
            <Grid container spacing={3} sx={{ mb: 3 }}>
              {contests.map((contest: any) => (
                <Grid item xs={12} sm={6} md={3} key={contest.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      bgcolor: "rgb(247, 250, 255)",
                      border: "1px solid rgb(237, 242, 247)",
                      boxShadow: "none",
                      borderRadius: 2,
                    }}
                  >
                    <CardMedia
                      component="div"
                      sx={{
                        pt: "56.25%",
                        position: "relative",
                        bgcolor: "white",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: '100%',
                          height: '100%'
                        }}
                      >
                        <img
                          src={process.env.STORAGE_CONTEST_URL + '/storage/' + contest.thumbnail || logo}
                          alt={contest.title.toString()}
                          width="100%"
                          height="100%"
                          style={{
                            objectFit: 'cover'
                          }}
                        />
                      </Box>
                    </CardMedia>
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 2,
                          fontSize: '16px',
                          fontWeight: 600,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          height: '48px',
                          bgcolor: 'transparent'
                        }}
                      >
                        {contest.title}
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            mb: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical'
                          }}
                        >
                          {/* {contest.description?.replace(/<[^>]*>/g, '')} */}
                          {contest.description ? decodeHTMLEntities(contest.description.replace(/<[^>]*>/g, "")) : ""}
                        </Typography>
                      </Box>
                      <Button
                        href={process.env.STORAGE_CONTEST_URL + '/events/' + contest.slug + '?required=login'}
                        target="_blank"
                        rel="noopener noreferrer"
                        fullWidth
                        variant="contained"
                        sx={{
                          bgcolor: "rgb(255, 90, 31)",
                          "&:hover": {
                            bgcolor: "rgb(230, 81, 28)",
                          },
                        }}
                      >
                        Go
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <IconButton
              onClick={handlePrevPage} // Chuyển trang về trước
              sx={{
                position: "absolute",
                left: -16,
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                "&:hover": {
                  bgcolor: "rgb(247, 250, 255)",
                },
              }}
            >
              <ArrowBackIos />
            </IconButton>
            
            <IconButton
              onClick={handleNextPage} // Chuyển trang tới tiếp theo
              sx={{
                position: "absolute",
                right: -16,
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                "&:hover": {
                  bgcolor: "rgb(247, 250, 255)",
                },
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    "&.Mui-selected": {
                      bgcolor: "rgb(15, 105, 185)",
                      color: "white",
                      "&:hover": {
                        bgcolor: "rgb(13, 94, 166)",
                      },
                    },
                  }}
                />
              )}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
